import React, { ReactElement } from "react";

// Constant
import { POLLS_TYPE } from "../../utils/constants";

// Components
import MultipleChoice from "./multipleChoice/multipleChoice.component";
import Rating from "./rating/rating.component";
import Question from "./question/question.component";
import WordCloud from "./wordCloud/wordCloud.component";
import Quiz from "./quiz/quiz.component";
import Ranking from "./ranking/ranking.component";
import NotFound from "./notFound/notFound.component";

// Styles
import "./polls.layout.scss";

function getComponent(type) {
  switch (type) {
    case POLLS_TYPE.MULTIPLE_CHOICE:
      return MultipleChoice;
    case POLLS_TYPE.RATING:
      return Rating;
    case POLLS_TYPE.QUESTION:
      return Question;
    case POLLS_TYPE.WORD_CLOUD:
      return WordCloud;
    case POLLS_TYPE.QUIZ:
      return Quiz;
    case POLLS_TYPE.RANKING:
      return Ranking;
    default:
      return NotFound;
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const PollsLayout = (props): ReactElement => {
  const Component = getComponent(props.type);
  return <Component {...props} />;
};

export default PollsLayout;
